import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Card, CardHeader, CardContent, Icon, Tabs, Tab } from '@material-ui/core'
import {compose} from 'redux'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import autobind from 'autobind-decorator'
import { RouteComponentProps, withRouter } from 'react-router'
import { CtxCotation, withCotation } from 'src/page/Consumer/Cotation/CotationProvider'
import { withToast } from 'src/shared/Toast'
import { WithToast } from 'src/shared/Toast/Toast'
import ChartContext from 'src/shared/Cotation/chart/ChartContext'

import { AUTOCALL_RENDEMENT_data } from 'src/shared/Cotation/chart/data/AutocallRendement'
import { COLLAR_KI_KO_data } from 'src/shared/Cotation/chart/data/CollarKIKO'
import { WEDDING_CAKE_OPTIONS_data } from 'src/shared/Cotation/chart/data/WeddingCakeOptions'
import { TUNNEL_ASYMETRIQUE_data } from 'src/shared/Cotation/chart/data/TunnelAsymetrique'
import { TERME_ASYMETRIQUE_data } from 'src/shared/Cotation/chart/data/TermeAsymetrique'
import { TERME_PARTICIPATIF_ASYMETRIQUE_data } from 'src/shared/Cotation/chart/data/TermeParticipatifAsymetrique'
import { TERME_ASYMETRIQUE_DESACTIVANT_data } from 'src/shared/Cotation/chart/data/TermeAsymetriqueDesactivant'
import { TERME_ACCUMULATEUR_KO_data } from 'src/shared/Cotation/chart/data/TermeAccumulateurKO'
import { TARF_data } from 'src/shared/Cotation/chart/data/TARF'
import { WEDDING_CAKE_ACCUMULATEUR_data } from 'src/shared/Cotation/chart/data/WeddingCakeAccumulateur'
import { SWAP_data } from 'src/shared/Cotation/chart/data/Swap'
import { CAP_data } from 'src/shared/Cotation/chart/data/Cap'
import { COLLAR_data } from 'src/shared/Cotation/chart/data/Collar'
import { SWAP_KO_data } from 'src/shared/Cotation/chart/data/SwapKO'
import { CAP_KO_data } from 'src/shared/Cotation/chart/data/CapKO'
import { COLLAR_KO_data } from 'src/shared/Cotation/chart/data/CollarKO'
import { TERME_SEC_data } from 'src/shared/Cotation/chart/data/TermeSec'
import Alert from 'src/shared/Alert/Alert'


const styles = (t: Theme) => createStyles({
    card: {
        height: '100%'
    },
    cardTitle: {
        fontSize: '1.2rem',
        textTransform: 'uppercase'
    },
    tabsRoot: {
        marginBottom: t.spacing.unit * 4,
        borderBottom: '1px solid #e8e8e8'
    },
    tabsIndicator: {
        backgroundColor: t.palette.primary.main
    },
    tabRoot: {
        textTransform: 'initial',
        minWidth: 72,
        fontWeight: t.typography.fontWeightRegular,
        marginRight: t.spacing.unit * 4,
        '&:hover': {
            color: t.palette.primary.main,
            opacity: 1,
        },
        '&$tabSelected': {
            color: t.palette.primary.main,
            fontWeight: t.typography.fontWeightMedium,
        },
        '&:focus': {
            color: t.palette.primary.main,
        },
    },
    toggleWpr:{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: t.spacing.unit * 2
    }
});


interface IProps extends WithI18n,
  WithToast,
  WithStyles<typeof styles>,
  RouteComponentProps<any>,
  CtxCotation  {
}

interface IStates {
    tabActive: number;
    chartsData: any;
    dataAvaible: boolean;
}

class Graph extends React.Component<IProps, IStates> {
    state = {
        tabActive: 0,
        chartsData: undefined,
        dataAvaible: false,
    }

    render() {
        const {classes, detail, t} = this.props;
        const {tabActive, dataAvaible, chartsData} = this.state;
        
        return (
            <Card className={classes.card} style={{overflow: 'visible'}}>
                <CardHeader classes={{title: classes.cardTitle}}  title={
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <Icon style={{marginRight: '5px'}}>show_chart</Icon>
                        {t.Cotation_graphic_payoff}
                    </div>
                } />

                <CardContent style={{overflow: 'visible'}}>
                    <Tabs
                        value={tabActive}
                        onChange={this.modeChange}
                        classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                        scrollable scrollButtons="off"
                    >
                        <Tab
                            disableRipple
                            classes={{ root: classes.tabRoot}}
                            label="Graphique théorique"
                        />
                        {detail && detail.can_see_specific_payoff &&
                            <Tab
                                disableRipple
                                classes={{ root: classes.tabRoot}}
                                label="Graphique réel"
                            />
                        }
                    </Tabs>
                    
                    {dataAvaible &&
                        <ChartContext data={chartsData} withDescribe={true} isDefault={tabActive === 0}/>
                    }
                    {!dataAvaible &&
                        <Alert type="info">{t.Cotation_no_charts}</Alert>
                    }
                </CardContent>
            </Card>
        )
    }

    componentDidUpdate(prevProps){
        const {formParams} = this.props
        if(prevProps.formParams !== formParams && formParams){
            const data = this.generateChartAvaiable()
            if(data){
                this.setState({chartsData: data, dataAvaible: true})
            }
        }
    }

    @autobind
    private generateChartAvaiable(){
        const {formParams, match} = this.props
        if(formParams){
            switch(match.params.productType){
                case 'COLLAR_KI_KO':
                    return COLLAR_KI_KO_data(formParams).filter(d => d.isAvailable === true)
                case 'AUTOCALL_RENDEMENT':
                    return AUTOCALL_RENDEMENT_data(formParams).filter(d => d.isAvailable === true)
                case 'WEDDING_CAKE_OPTIONS': 
                    return WEDDING_CAKE_OPTIONS_data(formParams).filter(d => d.isAvailable === true)
                case 'TUNNEL_ASYMETRIQUE':
                    return TUNNEL_ASYMETRIQUE_data(formParams).filter(d => d.isAvailable === true)
                case 'TERME_PARTICIPATIF':
                    return TERME_PARTICIPATIF_ASYMETRIQUE_data(formParams).filter(d => d.isAvailable === true)
                case 'TERME_ASYMETRIQUE':
                    return TERME_ASYMETRIQUE_data(formParams).filter(d => d.isAvailable === true)
                case 'TERME_ASYMETRIQUE_DESACTIVANT':
                    return TERME_ASYMETRIQUE_DESACTIVANT_data(formParams).filter(d => d.isAvailable === true)
                case 'TERME_ACCUMULATEUR_KO':
                    return TERME_ACCUMULATEUR_KO_data(formParams).filter(d => d.isAvailable === true)
                case 'TARF':
                    return TARF_data(formParams).filter(d => d.isAvailable === true)
                case 'WEDDING_CAKE_ACCUMULATEUR':
                    return WEDDING_CAKE_ACCUMULATEUR_data(formParams).filter(d => d.isAvailable === true)
                case 'SWAP':
                    return SWAP_data(formParams).filter(d => d.isAvailable === true)
                case 'CAP':
                    return CAP_data(formParams).filter(d => d.isAvailable === true)
                case 'COLLAR':
                    return COLLAR_data(formParams).filter(d => d.isAvailable === true)
                case 'SWAP_KO':
                    return SWAP_KO_data(formParams).filter(d => d.isAvailable === true)
                case 'CAP_KO':
                    return CAP_KO_data(formParams).filter(d => d.isAvailable === true)
                case 'COLLAR_KO':
                    return COLLAR_KO_data(formParams).filter(d => d.isAvailable === true)
                case 'DIY_PLACEMENT':
                    return undefined;
                case 'DIY_CHANGE':
                    return undefined;
                case 'TERME_SEC':
                    return TERME_SEC_data(formParams).filter(d => d.isAvailable === true)
                default:
                    return "";
            }
        } else {
            return undefined;
        }
    }

    @autobind
    private modeChange(event, value) {
        this.setState({ tabActive: value });
    };

}

export default compose(
    withCotation,
    withI18n,
    withToast,
    withRouter,
    withStyles(styles),
)(Graph)



// WEBPACK FOOTER //
// ./src/page/Consumer/Cotation/Graph.tsx